// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button_3RtIV","small":"Button_small_1JaAN","transparent":"Button_transparent_2ry7a","grayscale":"Button_grayscale_1R_Uy","back":"Button_back_38P1-"};
    if(module.hot) {
      // 1789136758750
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  